module.exports = "./img/ae2e672b857c2c920b5c6f4cbeb038cf.jpg";